/*
* To have dynamic panes and pass random content to it, CustomMuiAccordion element has
* to follow specific markup for its Panes labels and data.
*
* See example in stories.
*
* Attributes like "panes, cols, skipData" mostly relate to rendering of data on
* Drupal side. "skipData" indicates to not try to render REST view in Drupal, if
* set to TRUE.
*
* */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import {parseGutenbergReact} from "../../../api/global";

const useStyles = makeStyles((theme) => ({
      IncAccord: {
        width: '100%',
        "& svg": {
          color: theme.palette.grey[900],
        }
      },
      IncAccordLbl: {
        // fontSize: theme.typography.pxToRem(18),
        flexBasis: '100%',
        flexShrink: 0,
        color: theme.palette.grey[900],
        fontWeight: 700,
        margin: 0,
        fontSize: 20,
      },
    }),
);

export default function CustomMuiAccordion(props) {
  let {children, panes, cols, skipData, block} = props;
  if ((!cols || !children) && block?.data) {
    cols = !cols ? block?.data.cols : cols;
  }
  if (!cols && !children) {
    return null;
  }

  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  let i = 0;
  return (
      <Container>
        <Grid container>
          <Grid item xs={12}>
            <div className={classes.IncAccord}>
              {cols && cols.map((val, ind) => {
                let body = (
                    <AccordionDetails key={`det-${val.key}-${ind}`}>
                      <Typography component={`div`}>
                        {val.data.map((gb, igb) => {
                          return parseGutenbergReact(`inner-${igb}`, gb, skipData);
                        })
                        }
                      </Typography>
                    </AccordionDetails>
                );
                const out = (
                    <Accordion key={`acc-${val.key}-${ind}`}
                               expanded={expanded === `panel${ind}`}
                               onChange={handleChange(`panel${ind}`)}>
                      <AccordionSummary expandIcon={<ExpandMoreIcon/>}
                                        aria-controls={`panel${ind}bh-content`}
                                        id={`panel${ind}bh-header`}>
                        <Typography component={`div`}
                                    className={classes.IncAccordLbl}>{val.attrs.label}</Typography>
                      </AccordionSummary>
                      {body}
                    </Accordion>
                );
                return out;
              })
              }
              {children && children.map((val, ind) => {
                let body = null;
                if (val.key.includes('acc-lbl-')) {
                  if (children[ind + 1] && children[ind + 1].key.includes(`acc-data-${i + 1}`)) {
                    body = (
                        <AccordionDetails key={`det-${val.key}-${ind}`}>
                          <Typography component={`div`}>
                            {children[ind + 1]}
                          </Typography>
                        </AccordionDetails>
                    );
                    i += 1;
                  }
                  const out = (
                      <Accordion key={`acc-${val.key}-${ind}`}
                                 expanded={expanded === `panel${i}`}
                                 onChange={handleChange(`panel${i}`)}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon/>}
                            aria-controls={`panel${i}bh-content`}
                            id={`panel${i}bh-header`}
                        >
                          <Typography component={`div`}
                                      className={classes.IncAccordLbl}>{val.props.children}</Typography>
                        </AccordionSummary>
                        {body}
                      </Accordion>
                  );
                  return out;
                }
              })
              }
            </div>
          </Grid>
        </Grid>
      </Container>
  );
}
